import React, { useState, PropsWithChildren, useEffect } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { InputDropdown } from 'component-library/index';
import './Tabs.css';
import { useWidthContext } from '../../providers/Width';
import { getSecChildren } from '../PageSection/PageSection';
import withAsyncImport from '../../withAsyncImport';
import { wrapTrademarkSuperscript } from '../../utils/cob-utils';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { Title, Section, Container } from '../../importCL';
const CobGrid = withAsyncImport(() => import('../CobGrid/CobGrid'));

interface ITab {
    title?: string;
    url?: string;
    link?: boolean;
}

interface ITabsProps extends MappedComponentProperties {
    cqItems?: string[];
    cqItemsOrder?: string[];
    tabs?: ITab[];
}

export const TabsEditConfig = {
    emptyLabel: 'Tabs',
    isEmpty: (props: PropsWithChildren<ITabsProps>) => {
        return !props || !props.tabs;
    },
};

const Tabs = (props: PropsWithChildren<ITabsProps>): JSX.Element => {
    const [activeTab, setActive] = useState(props.tabs ? props.tabs[0].title : '');
    const { width } = useWidthContext();
    const [tabOptions, setTabOptions] = useState<string[]>([]);

    useEffect(() => {
        const shallowTabOptions: string[] = [];
        props.tabs?.map((tab) => {
            if (tab.title) {
                shallowTabOptions.push(tab.title);
            } else {
                shallowTabOptions.push('No Tab Name');
            }
        });
        setTabOptions(shallowTabOptions);

        if (props.tabs) {
            const index = props.tabs.map(tab => tab.title).indexOf(activeTab);
            if (index !== null) {
                if (props.tabs[index].link && props.tabs[index].url !== undefined) {
                    window.location.href = (props.tabs[index].url as string);
                }
            }
        }
    }, [props.tabs, activeTab]);

    return (
        <div id='tabs' className='Tabs'>
            <Section className='!pt-16 !pb-0 bg-grey-alabaster !max-w-in md:!pt-8' containerClass='!p-0 !m-0 !max-w-[initial]'>
                <Container>
                    {width > 769 ? <span className='Tabs__tabs flex'>
                        {props.tabs && props.tabs.map((tab, index) => (
                            <button className={activeTab === tab.title ? 'Tabs__tabOpen Tabs__tab bg-white' : 'Tabs__tab'}
                                key={index} onClick={() => setActive(tab.title)} >
                                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 25' fill='none'>
                                    <path d='M7.5 3.41406L16.5 12.4141L7.5 21.4141' stroke='#0a5ec0' strokeWidth='4' strokeLinecap='round' strokeLinejoin='round'/>
                                </svg>
                                <Title className='leading-6 mb-0 ml-4 text-[1.125rem]' tag='h2' tabIndex={0}>{transformHTMLParserLinks(wrapTrademarkSuperscript(tab.title))}</Title>
                            </button>
                        ))}
                    </span> :
                        <div className='flex justify-center items-center'>
                            <div className='w-4/5'>
                                <InputDropdown name='tabs' setValue={setActive} options={tabOptions} value={activeTab}/>
                            </div>
                        </div>}
                </Container>
            </Section>
            <div className='!p-0'>
                <div className='Tabs__content'>
                    {props.tabs && props.tabs.map((tab, index) => (
                        <div key={index}>
                            {/* This is a single line for a reason, don't change it */}
                            {(props.isInEditor && !tab.link) && <CobGrid isInEditor={true} cqPath={`${props.cqPath}/tabs${index}`} cqItems={getSecChildren(props, `tabs${index}`)} cqItemsOrder={props.cqItems[`tabs${index}`][':itemsOrder']}/>}
                            {(!props.isInEditor && !tab.link && activeTab === tab.title) && <CobGrid isInEditor={false} cqPath={`${props.cqPath}/tabs${index}`} cqItems={getSecChildren(props, `tabs${index}`)} cqItemsOrder={props.cqItems[`tabs${index}`][':itemsOrder']}/>}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Tabs;
